var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-bar"},[_c('div',{staticClass:"title",style:({'color':_vm.color})},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"absoluteImg",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('img',{staticStyle:{"width":".52rem"},attrs:{"src":_vm.white ? _vm.fanhuiWhite : _vm.fanhui,"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61484345","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/top-bar/index.vue
// module id = null
// module chunks = 